import React, { FC } from 'react'
import './styles.scss'

export const Loader: FC = () => <div className="loader" />
